<script>
export default {
    props: {
        dark: {
            required: false,
            default: true,
        },
        left: {
            required: false,
            default: false,
        },
        right: {
            required: false,
            default: false,
        },
        dense: {
            required: false,
            default: false,
        },
        large: {
            required: false,
            default: false,
        },
        small: {
            required: false,
            default: false,
        },
        'x-large': {
            required: false,
            default: false,
        },
        'x-small': {
            required: false,
            default: false,
        },
    }
}
</script>
